import { render } from "./PriceListForm.vue?vue&type=template&id=72e8669c"
import script from "./PriceListForm.vue?vue&type=script&lang=js"
export * from "./PriceListForm.vue?vue&type=script&lang=js"

import "./PriceListForm.vue?vue&type=style&index=0&id=72e8669c&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__